export default __webpack_public_path__ + "static/Forest---Header---1-7bfb9b024c555f6287bf848171742790.jpg";